import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Row, Col, Drawer, Divider, InputNumber, TreeSelect } from 'antd';
import BaseRadioList from '@/components/Elements/BaseRadios';
import { isMobile } from 'react-device-detect';
import { _newLine, makeTree } from '@/utils/helpers';
import { createProcedure, updateProcedure, getProcedureActive } from '@/redux/actions/procedureActions';
import BaseSelect from '@/components/Elements/BaseSelect';
import { getUnitActive } from '@/redux/actions/unitActions';

class ProcedureForm extends Component {
    constructor() {
        super();
        this.state = {
            loadingForm: false,
        };
    }

    componentDidMount() {
        this.props.getUnitActive();
        this.props.getProcedureActive();
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            delete values.documents;

            if (!err) {
                try {
                    this.setState({ loadingForm: true })
                    console.log('values: ', values)
                    if (this.props.currentItem) {
                        await this.props.updateProcedure(this.props.currentItem.id, values);
                        this.onClose();
                    } else {
                        await this.props.createProcedure(values);
                        this.onClose();
                    }
                    this.props.reloadData();
                } catch (error) {
                    this.setState({ loadingForm: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({
            loadingForm: false
        })
    }

    render() {
        var { loadingForm } = this.state;
        var { visible, currentItem, procedureActiveList, unitActiveList } = this.props;
        const { getFieldDecorator } = this.props.form;
        const procedureParentTree = makeTree(procedureActiveList || [], 0);

        console.log('currentItem: ', currentItem)

        return (
            <Drawer
                visible={visible}
                title={currentItem ? "Sửa thủ thuật" : "Thêm thủ thuật mới"}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.onClose()}>
                            Huỷ
                        </Button>
                        <Divider type="vertical" />
                        <Button loading={loadingForm} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentItem ? "Cập nhật" : "Thêm mới"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label="Tên thủ thuật">
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.name : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Mã thủ thuật">
                                    {getFieldDecorator('code', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.code : null
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Thời gian thực hiện (phút)">
                                    {getFieldDecorator('execution_time', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.execution_time : null
                                    })(<InputNumber className='w-100' min={1} />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Điểm đánh giá">
                                    {getFieldDecorator('pain_score', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.pain_score : null
                                    })(<InputNumber className='w-100' min={1} max={100} placeholder='1 - 100' />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Đơn vị tính">
                                    {getFieldDecorator('unit_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.unit_id : null
                                    })(
                                        <BaseSelect
                                            options={unitActiveList || []}
                                            optionValue="id"
                                            showSearch
                                            optionLabel="name"
                                            placeholder="Chọn"
                                            className="w-100"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Parent">
                                    {getFieldDecorator('parent_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng điền!',
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.parent_id : 0
                                    })(
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                            treeData={procedureParentTree || []}
                                            showSearch
                                            multiple={false}
                                            treeNodeFilterProp='title'
                                            allowClear
                                            placeholder="Chọn một bản ghi"
                                            treeDefaultExpandAll
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Mô tả chi tiết">
                                    {getFieldDecorator('description', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.description) : null
                                    })(
                                        <Input.TextArea rows={10} placeholder="Nhập mô tả chi tiết" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Ghi chú">
                                    {getFieldDecorator('note', {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentItem ? _newLine(currentItem.note) : null
                                    })(
                                        <Input.TextArea />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Form.Item label="Trạng thái">
                                    {getFieldDecorator('status', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentItem ? currentItem.status : 1
                                    })(
                                        <BaseRadioList
                                            options={[
                                                { label: "Active", value: 1 },
                                                { label: "Inactive", value: 0 }
                                            ]}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        unitActiveList: state.unitReducer.unitActiveList,
        procedureActiveList: state.procedureReducer.procedureActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createProcedure: (data) => dispatch(createProcedure(data)),
        updateProcedure: (id, data) => dispatch(updateProcedure(id, data)),
        getUnitActive: () => dispatch(getUnitActive()),
        getProcedureActive: () => dispatch(getProcedureActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProcedureForm' })(ProcedureForm));
